// Idioma fuente: las claves se escriben contra este fichero.
export default {
  common: {
    close: "Cerrar",
    retry: "Intentar de nuevo",
    cancel: "Cancelar",
    reset: "Restablecer",
    change: "Cambiar",
  },
  roles: {
    teacher: "Profesor",
    moderator: "Moderador",
    student: "Estudiante",
  },
  controlBar: {
    micDisabledByTeacher: "Micrófono deshabilitado por el profesor",
    micOn: "Activar micrófono",
    micOff: "Silenciar micrófono",
    micSettings: "Ajustes de micrófono",
    camDisabledByTeacher: "Cámara deshabilitada por el profesor",
    noCamera: "Sin cámara detectada",
    camOn: "Activar cámara",
    camOff: "Desactivar cámara",
    camSettings: "Ajustes de cámara",
    screenUnsupported: "Tu navegador móvil no permite compartir pantalla",
    screenDisabledByTeacher: "Compartir pantalla deshabilitado por el profesor",
    screenShare: "Compartir pantalla",
    screenStop: "Detener compartir pantalla",
    screenSwitch: "Cambiar pantalla compartida",
    captionOptions: "Idioma y tamaño de los subtítulos",    captionsReadIn: "Leo los subtítulos en",
    captionsHint: "Solo cambia {you}: lo que se dice en la clase te llega traducido a este idioma. Cada uno elige el suyo.",
    captionsHintYou: "tu pantalla",
    captionsSpeakIn: "Hablo en",
    captionsSpeakHint: "Con esto se transcribe {mic}. Solo tu voz: cada uno dice en qué idioma habla.",
    captionsSpeakHintMic: "tu micrófono",
    captionSize: "Tamaño del subtítulo",
    captionsOn: "Activar subtítulos en vivo",
    captionsOff: "Desactivar subtítulos en vivo",
    captionsHide: "Ocultar subtítulos",
    captionsShow: "Mostrar subtítulos",
    leave: "Salir de la sesión",
    more: "Más opciones",
  },
  captions: {
    untranslated: "Aún sin traducir · {lang}",
    size: {
      sm: "Pequeño",
      md: "Mediano",
      lg: "Grande",
      xl: "Muy grande",
    },
  },
  sessionMenu: {
    title: "Menú de la sesión",
    section: "Sesión",
    code: "Código",
    codeHide: "Ocultar código",
    codeShow: "Mostrar código",
    copyInvite: "Copiar enlace de invitación",
    recordStart: "Grabar la sesión",
    recordStop: "Detener grabación ({duration})",
    recordPause: "Pausar grabación",
    recordResume: "Reanudar grabación",
    recordPauseHint: "Lo pausado no se graba",
    recordPausedHint: "En pausa: no se está grabando",
    subtitles: "Subtítulos automáticos",
    subtitlesOn: "Se generará un .vtt al detener",
    subtitlesOff: "Desactivados",
    fullscreen: "Pantalla completa",
    fullscreenExit: "Salir de pantalla completa",
    endSession: "Finalizar la sesión",
    endSessionHint: "Se acaba la clase para todos",
    endSessionConfirm: "Se acaba la clase para todo el mundo y la sala queda cerrada. Para volver a abrirla hay que cambiarle el horario a la actividad.",
    endSessionCancel: "Cancelar",
    endSessionConfirmYes: "Finalizar",
  },
  sidePanel: {
    title: "Panel de la sesión",
    open: "Abrir el panel de la sesión",
    close: "Cerrar el panel",
    back: "Volver",
    tabs: {
      chat: "Chat",
      attendees: "Asistentes",
      transcript: "Transcripción",
      share: "Compartir contenido",
      settings: "Mis ajustes",
    },
  },
  transcript: {
    note: "En {lang}, tu idioma de lectura.",
    copy: "Copiar",
    copyTitle: "Copiar la transcripción",
    copied: "Copiada",
    emptyOff: "Los subtítulos en vivo están desactivados. Cuando el moderador los active, aquí quedará todo lo que se diga.",
    emptyIdle: "Todavía no se ha dicho nada. Las frases irán apareciendo aquí según se hablen.",
    jumpToLatest: "Ir a lo último",
  },
  hand: {
    chatMicBlocked: "🔒 {by} ha bloqueado el micrófono de {name}",
    chatMicAllowed: "🔓 {by} ha permitido el micrófono de {name}",
    chatCamBlocked: "🔒 {by} ha bloqueado la cámara de {name}",
    chatScreenBlocked: "🔒 {by} ha bloqueado la pantalla compartida de {name}",
    chatCamAllowed: "🔓 {by} ha permitido la cámara de {name}",
    chatScreenAllowed: "🔓 {by} ha permitido la pantalla compartida de {name}",
    chatExpelled: "⛔ {by} ha expulsado a {name}",
    chatGranted: "🎤 {by} ha dado la palabra a {name}",
    chatRevoked: "🔇 {by} ha quitado la palabra a {name}",
    chatCamGranted: "📷 {by} ha activado la cámara de {name}",
    chatCamRevoked: "🚫 {by} ha desactivado la cámara de {name}",
    grantCam: "Activar su cámara",
    revokeCam: "Desactivar su cámara",
    camGranted: "El profesor te ha activado la cámara: ya puedes encenderla.",
    camTaken: "El profesor ha desactivado tu cámara.",
    raise_: "Levantar la mano",
    lower: "Bajar la mano",
    chatRaised: "✋ {name} ha levantado la mano",
    notifyRaised: "✋ {name} ha levantado la mano",
    grant: "Dar la palabra",
    revoke: "Quitar la palabra",
    lowerFor: "Bajar su mano",
    options: "Ver en participantes",
    gone: "Ya no está en la sala",
    youHaveTheFloor: "Tienes la palabra: activa tu micrófono para hablar.",
    floorTaken: "Se ha terminado tu turno de palabra.",
    raisedYou: "Has levantado la mano. El moderador te dará la palabra.",
    loweredYou: "Has bajado la mano.",
    hasFloor: "Tiene la palabra",
    raisedBadge: "Mano levantada",
    raisedCount: "{n} con la mano levantada",
  },
  chat: {
    title: "Chat de la reunión",
    emptyTitle: "Los mensajes aparecerán aquí",
    emptyHint: "Sé el primero en enviar un mensaje",
    placeholder: "Envía un mensaje a todos",
    hint: "Enter para enviar, Shift+Enter nueva línea",
    roleTeacher: "PROFESOR",
    roleModerator: "MOD",
  },
  share: {
    screenStart: "Compartir pantalla",
    screenStop: "Dejar de compartir pantalla",
    screenUnsupported: "No disponible en este navegador",
    disabledByTeacher: "Deshabilitado por el profesor",
    screenSwitch: "Cambiar pantalla compartida",
    screenSwitchHint: "Elige otra ventana o pestaña",
    pdfStart: "Presentar PDF",
    pdfStop: "Detener presentación PDF",
    pdfHint: "Comparte un documento página a página",
    empty: "No hay nada que puedas compartir en esta sesión.",
  },
  participants: {
    lockedNote: "Los permisos en gris vienen de la configuración de la sesión en Moodle y solo se pueden cambiar allí.",
    setInMoodle: "Se cambia en la configuración de la sesión en Moodle",
    title: "Participantes",
    classroomControls: "Controles del aula",
    muteOnJoin: "Silenciar al unirse",
    allowStudentVideo: "Permitir cámaras de estudiantes",
    allowStudentAudio: "Permitir micrófonos de estudiantes",
    allowScreenShare: "Permitir compartir pantalla",
    allowChat: "Permitir chat",
    allowRecording: "Permitir grabación",
    muteAll: "Silenciar todos",
    camerasOff: "Apagar cámaras",
    search: "Buscar participante",
    you: "Tú",
    group: {
      teacher: "Profesores",
      moderator: "Moderadores",
      hands: "Turno de palabra",
      student: "Estudiantes",
    },
    micAllow: "Permitir micrófono",
    micBlock: "Bloquear micrófono",
    camAllow: "Permitir cámara",
    screenAllow: "Permitir compartir pantalla",
    camBlock: "Bloquear cámara",
    screenBlock: "Bloquear compartir pantalla",
    makeModerator: "Hacer moderador",
    makeTeacher: "Hacer profesor",
    expel: "Expulsar participante",
    empty: "No se encontraron participantes",
  },
  settings: {
    language: "Idioma de la interfaz",
    microphone: "Micrófono",
    micUnnamed: "Micrófono por defecto",
    noMics: "No se detectaron micrófonos",
    audioSettings: "Ajustes de audio",
    volume: "Volumen",
    noiseSuppression: "Supresión de ruido",
    advanced: "Ajustes avanzados",
    agc: "Potenciar micrófono (AGC)",
    agcHint: "Nivela tu voz en origen para que todos te oigan parejo (como Discord). Activado por defecto; desactívalo solo si te amplifica demasiado ruido de fondo.",
    normalize: "Normalizar volumen de los demás",
    normalizeHint: "Normalmente no hace falta: cada micrófono ya se nivela en origen. Actívalo solo si alguien concreto se sigue oyendo demasiado alto o bajo.",
    peakLimit: "Límite de picos",
    off: "apagado",
    micTest: "Probar micrófono",
    micTestStop: "Detener prueba",
    micLevel: "Nivel del micrófono",
    micTestPrivate: "Durante la prueba nadie más te oye.",
    camera: "Cámara",
    camUnnamed: "Cámara por defecto",
    noCams: "No se detectaron cámaras",
    videoFilters: "Filtros de vídeo",
    filterQuality: "Calidad del filtro",
    filterQualityLabel: "Calidad del filtro: {level}",
    mirrorOn: "Activar espejo",
    mirrorOff: "Desactivar espejo",
    mirrorHint: "Invierte tu cámara horizontalmente",
    bgImage: "Imagen de fondo",
    bgImageRemove: "Quitar imagen de fondo",
    bgImageHint: "Se aplica con Quitar fondo, Fondo borroso o Chroma",
    pipRounded: "Redondear bordes del PiP",
    pipSquare: "Quitar bordes del PiP",
    pipHint: "Esquinas redondeadas en la cámara",
    chat: "Chat",
    chatMute: "Ocultar notificaciones de mensajes",
    chatMuteHint: "Sin sonido ni avisos de mensajes nuevos",
    teacherMode: "Modo Profesor",
    overlayMode: "Modo overlay",
    overlayHint: "Coloca tu cámara sobre la pantalla compartida",
  },
  filters: {
    title: "Filtros de vídeo",
    open: "Abrir filtros",
    close: "Cerrar filtros",
    none: {
      name: "Sin filtro",
      description: "Vídeo original sin efectos",
    },
    backgroundRemoval: {
      name: "Quitar fondo",
      description: "Elimina el fondo mostrando solo la silueta",
    },
    backgroundBlur: {
      name: "Desenfocar fondo",
      description: "Desenfoca el fondo manteniendo a la persona nítida",
    },
    chromaGreen: {
      name: "Chroma key verde",
      description: "Recorta los píxeles verdes (green screen)",
    },
    quality: {
      basic: {
        name: "Básico",
        description: "15 fps · ligero (CPU baja)",
      },
      medium: {
        name: "Medio",
        description: "20 fps · equilibrado",
      },
      high: {
        name: "Alto",
        description: "30 fps · fluido",
      },
      max: {
        name: "Máximo",
        description: "30 fps · modelo de mayor precisión",
      },
    },
  },
  grid: {
    moreParticipants: "participantes",
    participantGone: "Se ha desconectado",
    netLost: "Conexión perdida",
    netWeak: "Conexión débil",
    netNone: "Sin conexión",
    micMuted: "Micrófono silenciado",
    camOff: "Cámara desactivada",
    screenOf: "Pantalla de {name}",
    yourScreen: "Tu pantalla",
  },
  audioMenu: {
    subtitle: "Ajustar volumen",
    noAudio: "Este participante no tiene audio disponible.",
    screen: "Pantalla compartida",
    mic: "Micrófono",
    autoNormalize: "Normalización automática",
    auto: "Auto",
  },
  overlay: {
    drag: "Arrastra para mover",
    position: "Cambiar posición",
    hide: "Ocultar overlay",
  },
  pdf: {
    title: "Presentación PDF",
    whiteboard: "Pizarra",
    maximize: "Maximizar",
    restore: "Restaurar tamaño",
    color: "Color",
    width: "Grosor",
    fill: "Rellenar formas",
    undo: "Deshacer (Ctrl+Z)",
    redo: "Rehacer (Ctrl+Y)",
    clear: "Limpiar lienzo",
    deleteSelected: "Borrar elemento seleccionado (Supr)",
    change: "Cambiar PDF",
    changeCurrent: "Cambiar PDF (actual: {file})",
    load: "Cargar PDF",
    loading: "Cargando PDF...",
    loadError: "No se pudo cargar el PDF",
    emptyHint: "Carga un PDF para empezar.",
    whiteboardHintA: "Dibuja libremente en el lienzo principal.",
    whiteboardHintB: "Estudiantes verán solo lo que hay en la pantalla, incluida tu cámara.",
    prevPage: "Página anterior",
    nextPage: "Página siguiente",
    rendering: "Renderizando página...",
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    zoomReset: "Restablecer zoom (100%)",
    panHint: "Mantén pulsado Ctrl y arrastra para mover la vista",
    tools: {
      select: "Seleccionar",
      pen: "Lápiz",
      line: "Línea",
      rect: "Rectángulo",
      circle: "Círculo",
      text: "Texto",
      eraser: "Borrador",
    },
    textPrompt: "Texto:",
  },
  room: {
    callTime: "Tiempo en llamada",
    latency: "Latencia de tu conexión (ida y vuelta)",
    connectionError: "Error de conexión",
    recTitle: "Esta sesión se está grabando",
    recPausedTitle: "Grabación en pausa: no se está grabando",
    recPausedBadge: "PAUSA",
    netPoor: "Conexión débil",
    netUnstable: "Conexión inestable",
    noMediaAccess: {
      camera: "Sin acceso a la cámara — revisa los permisos del navegador",
      mic: "Sin acceso al micrófono — revisa los permisos del navegador",
      both: "Sin acceso a la cámara ni al micrófono — revisa los permisos del navegador",
    },
    connecting: "Conectando...",
    reconnecting: "Reconectando...",
    reconnectAttempt: "Intento {n}",
    connectionLost: "Conexión perdida",
    reconnectFailed: "No se pudo reconectar automáticamente. Comprueba tu conexión a Internet y pulsa el botón.",
    reconnect: "Reconectar",
    recordingInProgress: "Tienes una grabación en curso ({duration}).",
    saveRecording: "Guardar grabación",
    confirmLeave: "¿Estás seguro de que quieres salir de la reunión?",
    unloadWarning: "La grabación sigue en marcha. Deténla antes de salir.",
    route: {
      turn: "Tráfico retransmitido por un servidor TURN (red restrictiva)",
      stun: "Conexión directa entre pares (descubierta vía STUN)",
      direct: "Conexión directa en la misma red local",
      directLabel: "Directo",
      pending: "Estableciendo ruta de conexión…",
    },
    notify: {
      captionsMicBlocked: "Tu voz aún no se está transcribiendo: haz clic en cualquier punto de la pantalla para activarla.",
      captionsOn: "Subtítulos en vivo activados. Elige tu idioma y su tamaño en el botón de subtítulos de la barra inferior; en «Transcripción» tienes todo lo dicho.",
      captionsOff: "Subtítulos en vivo desactivados.",
      serverRecDone: "Grabación finalizada. Estará disponible para importar en Moodle en unos minutos.",
      serverRecDoneLocal: "Grabación finalizada. Se está descargando a tu equipo.",
      recDownloading: "Grabación lista: descargándola a tu equipo…",
      recDownloadingParts: "Grabación lista en {n} partes: descargándolas a tu equipo…",
      lostButRecording: "Conexión perdida con la sala. La grabación local continúa.",
      subtitlesGenerating: "Generando subtítulos de la grabación…",
      subtitlesFailed: "No se pudieron generar los subtítulos",
      subtitleModel: "Cargando modelo de subtítulos…",
      subtitleModelPct: "Cargando modelo de subtítulos… {pct}%",
      recUnsupported: "Tu navegador no admite grabar la clase. Usa Chrome, Edge u otro basado en Chromium si necesitas grabar.",
      connectError: "Error al conectar",
      micMuted: "Micrófono silenciado",
      micOn: "Micrófono activado",
      audioError: "Error al cambiar audio",
      camOn: "Cámara activada",
      camOff: "Cámara desactivada",
      videoError: "Error al cambiar vídeo",
      screenOn: "Compartiendo pantalla",
      screenOff: "Compartir pantalla detenido",
      screenError: "Error al compartir pantalla",
      screenSwitched: "Pantalla compartida actualizada",
      screenSwitchError: "Error al cambiar la pantalla compartida",
      filterUnavailable: "El filtro no pudo cargarse (modelo de IA no disponible). Revisa la conexión o restricciones del navegador (CSP/ad-blocker). Detalle en la consola.",
      filterError: "Error al aplicar el filtro",
      pdfError: "Error al iniciar la presentación PDF",
      micSwitched: "Micrófono cambiado",
      micSwitchError: "Error al cambiar el micrófono",
      camSwitched: "Cámara cambiada",
      camSwitchError: "Error al cambiar la cámara",
      recSaved: "Grabación guardada. Descargando archivo...",
      recSaveError: "Error al guardar la grabación",
      recStoppedLocal: "Grabación detenida. Descargando archivo…",
      recStartedLocal: "Grabación local iniciada",
      recStartError: "No se pudo iniciar la grabación",
      recMergePending: "La grabación se ha guardado pero aún no se ha podido montar; se reintentará automáticamente",
      recStopping: "Deteniendo la grabación…",
      recStoppedServer: "Grabación detenida. El servidor procesa el vídeo, los subtítulos y el chat: ya puedes cerrar la ventana.",
      recStopError: "No se pudo confirmar que la grabación se detuviera. Puede seguir grabando — inténtalo de nuevo.",
      endSessionError: "No se pudo confirmar que la sesión se cerrara. Puede seguir abierta — inténtalo de nuevo.",
      recStartedServer: "Grabación de la sala iniciada",
      recStarting: "Iniciando la grabación de la sala…",
      recServerBusy: "No se ha podido grabar: el servidor de grabación está al máximo de su capacidad porque otras salas están grabando. Inténtalo de nuevo en unos minutos.",
      recResumed: "Grabación reanudada",
      recPaused: "Grabación en pausa. Pulsa «Reanudar grabación» para continuar en el mismo archivo.",
      participantMicBlocked: "Micrófono bloqueado para el participante",
      participantMicAllowed: "El participante ya puede activar su micrófono",
      participantCamBlocked: "Cámara bloqueada para el participante",
      participantScreenBlocked: "Pantalla compartida bloqueada para el participante",
      participantCamAllowed: "El participante ya puede activar su cámara",
      participantScreenAllowed: "El participante ya puede compartir pantalla",
      expelling: "Expulsando participante...",
      settingError: "Error al actualizar la configuración",
      settingUpdated: "Configuración actualizada",
      allMuted: "Todos los estudiantes han sido silenciados",
      allCamsOff: "Todas las cámaras de estudiantes han sido desactivadas",
      linkCopied: "Enlace de invitación copiado",
      linkCopyError: "Error al copiar el enlace",
    },
  },
  notify: {
    joinedAs: "Te has unido como {name}",
    reconnected: "Conexión restablecida",
    reconnectFailed: "No se pudo reconectar. Comprueba tu conexión a Internet.",
    beingRecorded: "Esta sesión se está grabando.",
    roleNotGranted: "Has entrado como estudiante: tu enlace de acceso no acredita el rol de profesor. Avisa al administrador del campus.",
    roomDataError: "Error al procesar los datos de la sala",
    participantJoined: "{name} se ha unido",
    participantLeft: "{name} ha salido",
    recordingStarted: "La sesión ha comenzado a grabarse.",
    recordingStopped: "Grabación detenida",
    recordingPaused: "Grabación en pausa: lo que pase ahora no se graba.",
    recordingResumed: "Grabación reanudada.",
    participantExpelled: "{name} ha sido expulsado",
    forcedMicOff: "El moderador ha silenciado tu micrófono",
    forcedCamOff: "El moderador ha desactivado tu cámara",
    forcedScreenOff: "El moderador ha detenido tu pantalla compartida",
    forcedMicBlocked: "El moderador ha bloqueado tu micrófono",
    forcedMicAllowed: "El moderador te permite de nuevo el micrófono: actívalo cuando quieras",
    forcedCamBlocked: "El moderador ha bloqueado tu cámara",
    cameraUnusable: "Esa cámara no funciona en este dispositivo; se ha quitado de la lista",
    forcedScreenBlocked: "El moderador te ha bloqueado compartir pantalla",
    forcedCamAllowed: "El moderador te permite de nuevo la cámara: actívala cuando quieras",
    forcedScreenAllowed: "El moderador te permite de nuevo compartir pantalla",
    youWereExpelled: "Has sido expulsado de la sala: {reason}",
    mutedAllBy: "{by} ha silenciado a todos los estudiantes",
    camsOffAllBy: "{by} ha desactivado todas las cámaras de estudiantes",
    settingsUpdatedBy: "{by} ha actualizado la configuración de la sala",
    youAreNow: "Ahora eres {role}",
    meshMode: "Estás en modo compatibilidad (malla): puede que no veas ni oigas a los demás. Recarga la página quitando \"?sfu=0\" de la dirección.",
    sfuReconnecting: "Reconectando con el servidor de vídeo…",
    sfuLost: "Se perdió la conexión con el servidor de vídeo. Reintentando…",
    sfuDown: "El servidor de vídeo no responde. Seguimos intentándolo; no verás ni oirás a nadie hasta que vuelva.",
    sfuDownDev: "El servidor de vídeo de pruebas está apagado: enciéndelo con «dev.bat up». La sala se conectará sola cuando arranque.",
    screenNotAllowed: "El profesor no permite compartir pantalla",
  },
  supervisor: {
    hiddenBanner: "Estás oculto como supervisor: nadie te ve ni te oye.",
    reveal: "Mostrarme",
    revealed: "Ya estás visible para la sala",
  },
  join: {
    otherRoomTitle: "Ya estás en otra sesión: {room}",
    otherRoomHint: "Sal de esa sesión para entrar en esta. En cuanto salgas, podrás unirte desde aquí.",
    supervisorNotice: "Entras como supervisor: nadie te verá ni te oirá hasta que decidas mostrarte.",
    sfuDownTitle: "El servidor de vídeo no responde",
    sfuDownHint: "Puedes entrar, pero no verás ni oirás a nadie hasta que vuelva. Inténtalo de nuevo en unos minutos.",
    sfuDownDevHint: "Las VMs de pruebas están apagadas: «dev.bat up» y espera un par de minutos. Este aviso desaparece solo.",
    loadingRoom: "Cargando la sala…",
    classroomNotice: "Aula virtual: entrarás con el micrófono y la cámara desactivados. Si quieres intervenir, levanta la mano y el profesor te los activará.",
    lockedByClassroom: "Desactivado en el aula virtual hasta que el profesor lo active",
    title: "¿Listo para unirte?",
    subtitle: "Comprueba tu audio y vídeo antes de entrar",
    roomCode: "Código de la reunión",
    roomCodePlaceholder: "Introduce un código",
    yourName: "Tu nombre",
    yourNamePlaceholder: "Introduce tu nombre",
    mediaWarning: "No se pudo acceder a la cámara o al micrófono",
    mediaWarningHint: "Puedes unirte de todos modos, o reintentar",
    cameraFilter: "Filtro de cámara",
    mirror: "Modo espejo",
    join: "Unirse ahora",
    joining: "Uniéndose...",
    errorRoomRequired: "Código de sala requerido",
    errorNameRequired: "Nombre requerido",
    errorGeneric: "No se pudo entrar en la sala",
  },
  home: {
    heroTitle: "Clases en directo,{break}sin {highlight}.",
    heroTitleHighlight: "complicaciones",
    heroSubtitle: "Plataforma educativa de retransmisión en {hd}, pizarra colaborativa y transcripción con IA. Sin pagos, ni registros, ni complicaciones. Simplifica tu vida.",
    heroSubtitleHd: "alta definición",
    heroLive: "En directo",
    create: "Crear una clase",
    join: "Unirse a una clase",
    featureHd: "Vídeos en HD",
    featureHdTip: "Alta Definición",
    featureHdDesc: "Streaming de vídeo en alta definición con WebRTC peer-to-peer",
    featureBoard: "Pizarra colaborativa",
    featureBoardDesc: "Dibujo y colaboración en tiempo real con múltiples participantes",
    featureAi: "Transcripción IA",
    featureAiDesc: "Transcripción automática y análisis de contenido con ML",
    featureRecording: "Grabación de pantalla",
    featureRecordingDesc: "Graba la pantalla o la cámara del profesor fácilmente durante la clase",
    featureChat: "Chat en directo",
    featureChatDesc: "Mensajería instantánea con historial persistente",
    featureBreakout: "Salas de estudio",
    featureBreakoutDesc: "Breakout rooms para trabajo en grupos pequeños",
  },
  create: {
    title: "Crear nueva clase",
    subtitle: "Configura tu nueva sesión de vídeo",
    roomName: "Nombre de la clase",
    roomNamePlaceholder: "ej. Matemáticas Avanzadas",
    roomType: "Tipo de sesión",
    types: {
      classroom: "Aula Virtual",
      meeting: "Reunión",
      webinar: "Webinar",
      recording: "Grabación",
    },
    maxParticipants: "Máximo de participantes",
    teacherNamePlaceholder: "Nombre del profesor",
    settings: "Configuración de la clase",
    submit: "Crear clase",
    creating: "Creando...",
    error: "No se pudo crear la clase",
    cardNumber: "n.º",
    chooseOne: "elige una",
    tickAll: "marca las que quieras",
  },
  pip: {
    close: "Cerrar vista pequeña",
  },
  sessionEnded: {
    title: "Sesión finalizada",
    lead: "Has salido de la sesión. Puedes volver a unirte o cerrar esta ventana.",
    leadRemoved: "Un moderador te ha sacado de la sesión. Ya puedes cerrar esta ventana.",
    titleClosed: "La sesión ya ha terminado",
    titleFinished: "La clase ha terminado",
    leadFinished: "Quien daba la sesión la ha dado por terminada. Ya puedes cerrar esta ventana.",
    titleNotOpen: "La sesión todavía no ha empezado",
    leadClosed: "Esta sesión terminó en su horario y ya no se puede entrar. Si crees que sigue en marcha, avisa a quien la imparte.",
    leadNotOpen: "Todavía no se puede entrar: la sala abre poco antes de la hora de inicio. Vuelve a abrirla desde el campus cuando empiece.",
    titleTimeLimit: "Se ha cerrado tu conexión",
    leadTimeLimit: "Llevabas 12 horas seguidas en la sala y la conexión se cierra sola pasado ese tiempo. Si sigues en la clase, vuelve a unirte.",
    rejoin: "Volver a unirse",
    close: "Cerrar ventana",
    closeHint: "Tu navegador no permite cerrar esta pestaña automáticamente: ciérrala tú.",
  },
}
